import editImage from './edit-image';

const editIcon = editImage;

export default editIcon;